import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";

export default function CartSheet() {
  const { items, open, setOpen, remove, setQty, total } = useCart();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col bg-background" data-testid="cart-sheet">
        <SheetHeader>
          <SheetTitle className="font-serif text-3xl text-left">Il tuo scrigno</SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-muted-foreground gap-4">
            <ShoppingBag size={40} strokeWidth={1} />
            <p>Il tuo scrigno è ancora vuoto.</p>
            <Button variant="outline" className="rounded-full" onClick={() => { setOpen(false); nav("/shop"); }} data-testid="cart-empty-shop-btn">
              Scopri gli incanti
            </Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto py-6 space-y-6">
              {items.map((i) => (
                <div key={i.product_id} className="flex gap-4" data-testid={`cart-item-${i.product_id}`}>
                  <img src={i.image} alt={i.name} className="h-24 w-20 object-cover rounded-md" />
                  <div className="flex-1">
                    <p className="font-serif text-lg leading-tight">{i.name}</p>
                    <p className="text-sm text-gold mb-2">{eur(i.price)}</p>
                    <div className="flex items-center gap-3">
                      <button onClick={() => setQty(i.product_id, i.quantity - 1)} className="p-1 border border-border rounded-full hover:bg-secondary transition-colors" data-testid={`cart-dec-${i.product_id}`}><Minus size={12} /></button>
                      <span className="text-sm w-5 text-center">{i.quantity}</span>
                      <button onClick={() => setQty(i.product_id, i.quantity + 1)} className="p-1 border border-border rounded-full hover:bg-secondary transition-colors" data-testid={`cart-inc-${i.product_id}`}><Plus size={12} /></button>
                      <button onClick={() => remove(i.product_id)} className="ml-auto text-muted-foreground hover:text-destructive transition-colors" data-testid={`cart-remove-${i.product_id}`}><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-border pt-6 space-y-4">
              <div className="flex justify-between text-lg">
                <span className="text-muted-foreground">Totale</span>
                <span className="font-serif text-2xl" data-testid="cart-total">{eur(total)}</span>
              </div>
              <Button className="w-full rounded-full bg-gold hover:bg-gold/90 text-white h-12 text-base" onClick={() => { setOpen(false); nav("/checkout"); }} data-testid="cart-checkout-btn">
                Procedi al pagamento
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
